/**
 * setLocalStorageData
 * @param {String} key - key for set localstorage
 * @param {String} value - value for localStorage can be object but must be to string
 */
export function setLocalStorageData(key, value) {
  localStorage.setItem(key, value)
}

/**
 * getLocalStorageData
 * @param {String} key - key for get localstorage
 * @returns {String} string return value
 */

export function getLocalStorageData(key) {
  return localStorage.getItem(key)
}

/**
 * removeLocalStorageData
 * @param {String} key - key for remove localStorage data
 */

export function removeLocalStorageData(key) {
  localStorage.removeItem(key)
}

/**
 * cleareLocalStorageData
 * clear all localStorage data
 */

export function cleareLocalStorageData() {
  localStorage.clear()
}
